module.exports = __webpack_public_path__ + "static/media/sidebar-1.2a39e7ea.png";